import type { SubscriptionProduct, AssertProduct } from '@/store/products'

declare const _prd_WOGXapZkx96W: {
	id: 'prd_WOGXa2DEV2pZkx96W'
	ident: 'prd_WOGXapZkx96W'
	sku: 'simple_premium_4w_10_99_4w_44_usd'
	type: 'subscription'
	phases: [
		{
			type: 'trial'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: 1
			price_id: 'prc_OfBEG2DEV2Shrvvrw'
			amount: 44
			amount_usd: 10.99
			cancellation_fee: null
			currency: 'USD'
			amount_with_discount: 10.99
			discount: 33.01
			promocode: 'BASE'
		},
		{
			type: 'regular'
			interval_unit: 'week'
			interval_duration: 4
			iteration_count: null
			price_id: 'prc_xr6jd2DEV2mp6Uf0A'
			amount: 44
			amount_usd: 44
			cancellation_fee: null
			currency: 'USD'
		},
	]
}
type _check = AssertProduct<typeof _prd_WOGXapZkx96W, SubscriptionProduct>
const prd_WOGXapZkx96W = { ident: 'prd_WOGXapZkx96W' } as typeof _prd_WOGXapZkx96W

export default prd_WOGXapZkx96W
